import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import CollectionsPanelFull from '../containers/CollectionsPanelFull';
import CollectionsPanelNarrow from '../containers/CollectionsPanelNarrow';

const CollectionsPanel = ({ configuration }) => (
  (
    <PanelMeasure
      configuration={configuration}
      component={{ full: CollectionsPanelFull, narrow: CollectionsPanelNarrow }}
    />
  )
);

export default CollectionsPanel;
